import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/multiLocationOverviewSaga";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../constants/ilearnUrls";

import FilterLevelFirstSelect from "./smartComponents/filterLevelFirstSelect";
import FilterLevelSecondSelect from "./smartComponents/filterLevelSecondSelect";
import FilterLevelThirdSelect from "./smartComponents/filterLevelThirdSelect";
import FilterLevelFourSelect from "./smartComponents/filterLevelFourthSelect";
import FilterLevelFiveSelect from "./smartComponents/filterLevelFifthSelect";
import DatePicker from "./smartComponents/datePicker";
import OverviewTable from "./smartComponents/overviewTable";
import AllLocationsTable from "./smartComponents/allLocationsTable";
import CustomDateRange from "./smartComponents/customDateRange";
import "./multiLocationOverview.css.scss";
import GroupBy from "./smartComponents/groupBy";

const MultiLocationOverviewModule = (props) => {
  const dispatch = useDispatch();
  const location = useSelector(
    (state) => state.multiLocationOverview.allLocationsData.tableInfo.colHeaders[0]
  );
  const {
    isLoading,
    filtersLoading,
    filtersDirty,
    availableFilters,
    selectedLevelFirst,
    selectedLevelSecond,
    selectedLevelThird,
    selectedLevelFourth,
    selectedLevelFifth,
    secondLevelFiltersLoading,
    thirdLevelFiltersLoading,
    selectedRequestDates,
    tablesLoading,
    allLocationsTablesLoading,
    fourthLevelFiltersLoading,
    breakdownTableLabel
  } = useSelector((state) => state.multiLocationOverview);

  useEffect(() => {
    initFetchData();
  }, []);

  const resetData = () => {
    initFetchData();
  };

  const addSticky = () => {
    const stickyElm = document.getElementById("sticky-select-bar");
    if (!stickyElm) return;

    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("isSticky", e.intersectionRatio < 1),
      { threshold: [1] }
    );
    observer.observe(stickyElm);
  };

  const initFetchData = () => {
    dispatch(actionCreators.fetchOverviewData(props));
  };

  const updateTables = () => {
    dispatch(actionCreators.requestNewTableData());
  };

  const canRenderUpdateButton = () => {
    if (
      filtersDirty &
      !isLoading &
      (selectedLevelFirst.length > 0) &
      (selectedLevelSecond.length > 0) &
      (selectedLevelThird.length > 0) &
      (selectedLevelFourth.length > 0) &
      (selectedLevelFifth.length > 0) &
      (selectedRequestDates.startDate !== "Invalid date") &
      (selectedRequestDates.endDate !== "Invalid date")
    ) {
      return true;
    }

    return false;
  };

  !isLoading &&
    setTimeout(() => {
      addSticky();
    }, 1000);
  const filterLevels = availableFilters?.filter_levels;
  const filterTitles = availableFilters?.filter_titles;

  return (
    <SectionToggle
      title="Multi Location Overview"
      customClass="multi-location-overview withSticky"
      autoHeight
      hideToggle
      learnMore={
        <KBLearnMore
          title="Multi Location Overview"
          description="This report shows performance metrics across all locations, giving you a unified view of how each site compares on key operational and revenue indicators. These insights help you evaluate regional patterns, identify high-performing locations, and support strategic multi-site decision-making."
          kbUrl={ILEARN_URLS.multiLocationOverview.overview}
        />
      }
      content={
        <div className="content-wrapper">
          {isLoading ? (
            <LoadingAnimation />
          ) : (
            <>
              {!filtersLoading && !isLoading && (
                <div className="edit-selections-bar" id="sticky-select-bar">
                  <div className="dates-container">
                    <div className="select-box" style={{ width: 362 }}>
                      <p className="offers-title">Date Range</p>
                      <CustomDateRange />
                    </div>
                    <div className="date-select-box multi" style={{ width: 317 }}>
                      <p>Date</p>
                      <DatePicker />
                    </div>
                  </div>
                  <div className="filters-container">
                    {filterLevels && filterLevels.includes("level_1") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[0]}</p>
                        <FilterLevelFirstSelect />
                      </div>
                    )}
                    {filterLevels && filterLevels.includes("level_2") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[1]}</p>
                        {!secondLevelFiltersLoading ? (
                          <FilterLevelSecondSelect />
                        ) : (
                          <LoadingAnimation uiLoader />
                        )}
                      </div>
                    )}
                    {filterLevels && filterLevels.includes("level_3") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[2]}</p>
                        {!thirdLevelFiltersLoading ? (
                          <FilterLevelThirdSelect />
                        ) : (
                          <LoadingAnimation uiLoader />
                        )}
                      </div>
                    )}
                    {filterLevels && filterLevels.includes("level_4") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[3]}</p>
                        {!fourthLevelFiltersLoading ? (
                          <FilterLevelFourSelect />
                        ) : (
                          <LoadingAnimation uiLoader />
                        )}
                      </div>
                    )}
                    <GroupBy />
                    {filterLevels && filterLevels.includes("level_5") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[4]}</p>
                        <FilterLevelFiveSelect />
                      </div>
                    )}
                    <div className="action-buttons">
                      {canRenderUpdateButton() && (
                        <button className="submit submit-button" onClick={updateTables}>
                          Update
                        </button>
                      )}
                      {filtersDirty && (
                        <button className="submit reset reset-button" onClick={resetData}>
                          Reset
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {tablesLoading ? (
                <LoadingAnimation />
              ) : (
                <div className=".all-locations-wrapper" style={{ backgroundColor: "transparent" }}>
                  <h1>All Locations</h1>
                  <div style={{ float: "left", width: "100%" }}>
                    <OverviewTable />
                  </div>
                </div>
              )}
            </>
          )}
          <>
            {allLocationsTablesLoading ? (
              <LoadingAnimation />
            ) : (
              <div
                className={`allLocationsDataWrapper all-locations-wrapper
                     ${location !== "Location" ? "resetAlignment" : ""}
                    `}
              >
                <h1>Breakdown by {breakdownTableLabel}</h1>
                <div className="allLocationsTableWrapper">
                  <AllLocationsTable />
                </div>
              </div>
            )}
          </>
        </div>
      }
    />
  );
};
export default MultiLocationOverviewModule;
